import { useCallback } from 'react'
import { isEqual } from 'lodash'


export type ShouldUpdateItem = {
    fieldName: string,
    valueExpr: string,
    localField?: string,
}
export type ShouldUpdateArray = Array<ShouldUpdateItem>

export interface IUseSelectionChangedCallbackArgs {
    value: any,
    setValue: Function,
    selectionMode: 'single' | 'multi' | 'multicsv' | 'range' | 'singlerange',
    displayExpr: Function,
}

// todo: add localField to every shouldUpdateItem making it required
export const useSelectionChangedCallback = (
    {
        value,
        setValue,
        selectionMode,
        displayExpr,
    }: IUseSelectionChangedCallbackArgs
) => {
    const callback = useCallback((row: any, rangeStart?: string) => {
        if (selectionMode === 'multi' || selectionMode === 'multicsv') {
            if (isEqual(row, value) || (row === null && value === null)) {
                return
            }
        } else if (selectionMode === 'single') {
            if ((row === null && value === null) ||
                (row && value && row.HDR_ID === value.HDR_ID)) {
                return
            }
        } else if (selectionMode === 'singlerange') {
            row ? setValue(displayExpr(row[0], false)) : setValue(null)
            return
        } else {
            // todo: handle range mode cases
            if (row === null) {
                setValue(null)
                return
            }

            setValue((value: string) => {
                let newValue = ''
                let hasPlusFormat = value && value.includes('+')
                if (rangeStart) {
                    // todo: use valueExpr here
                    newValue = `${rangeStart.replace('-', '/')}-${displayExpr(row, rangeStart.includes('+'))}`
                } else {
                    newValue = Array.isArray(row) ? row.map(x => displayExpr(x, hasPlusFormat)).join(',') : displayExpr(row, hasPlusFormat)
                }

                // todo: arrange value so ranges are in the beginning and
                // multiselected items are at the end

                let _value = null

                if (value === null) {
                    _value = newValue
                } else if (value.endsWith(',')) {
                    _value = `${value}${newValue}`
                } else {
                    _value = `${value},${newValue}`
                }

                const items = _value.split(',').map(i => i.trim())
                const ranges: string[] = []
                const multiselects: string[] = []

                items.forEach((item: string) => {
                    if (item.includes('-')) {
                        ranges.push(item)
                    } else {
                        multiselects.push(item)
                    }
                })

                _value = [...ranges, ...multiselects].join(',')

                return _value
            })
            return
        }
        setValue(row)
    }, [value, setValue, selectionMode, displayExpr])

    return callback
}
